import projectFolderDark from 'assets/projectFolderDark.svg';
import projectFolderWhite from 'assets/projectfolderWhite.svg';
import { cn } from 'lib/utils';

const sizeClasses = {
  sm: 'h-5 w-5',
  md: 'h-[30px] w-[30px]',
  lg: 'h-[40px] w-[40px]',
} as const;

interface ProjectFolderIconProps {
  className?: string;
  size?: keyof typeof sizeClasses;
  color?: string;
}

export function ProjectFolderIcon({
  className,
  size = 'sm',
  color,
}: Readonly<ProjectFolderIconProps>) {
  const dimensionClass = sizeClasses[size];

  if (color) {
    return (
      <svg
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        className={cn('shrink-0', dimensionClass, className)}
      >
        <path
          d="M1.96704 12.6491C1.65402 11.0797 1.49752 10.2951 1.94221 9.76333C1.97186 9.72788 2.00321 9.69363 2.03618 9.6607C2.53055 9.16675 3.40545 9.16675 5.15525 9.16675L14.8444 9.16675C16.5942 9.16675 17.4691 9.16675 17.9635 9.6607C17.9965 9.69363 18.0278 9.72788 18.0575 9.76333C18.5022 10.2951 18.3457 11.0797 18.0326 12.6491C17.5826 14.9055 17.3575 16.0337 16.5089 16.7268C16.451 16.7741 16.3913 16.8195 16.3299 16.8629C15.4301 17.5001 14.1721 17.5001 11.6562 17.5001H8.34347C5.82753 17.5001 4.56956 17.5001 3.66972 16.8629C3.60835 16.8195 3.54867 16.7741 3.49078 16.7268C2.64213 16.0337 2.4171 14.9055 1.96704 12.6491Z"
          stroke={color}
          strokeWidth="1.5"
        />
        <path
          d="M3.3335 9.16667L3.3335 4.58333C3.3335 3.43274 4.26624 2.5 5.41683 2.5L7.44152 2.5C7.99878 2.5 8.51916 2.7785 8.82827 3.24217L10.0002 5M10.0002 5L7.0835 5M10.0002 5L14.5835 5C15.7341 5 16.6668 5.93274 16.6668 7.08333V9.16667"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  return (
    <>
      <img
        src={projectFolderDark}
        alt=""
        aria-hidden="true"
        className={cn('shrink-0 object-contain dark:hidden', dimensionClass, className)}
      />
      <img
        src={projectFolderWhite}
        alt=""
        aria-hidden="true"
        className={cn('hidden shrink-0 object-contain dark:block', dimensionClass, className)}
      />
    </>
  );
}
